module.exports = __webpack_public_path__ + "static/product_development-bc4f728c000d3d0e16448f3f6f9e8bd7.svg";